'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

var UtilityNavItem = require('./UtilityNavItem/UtilityNavItem.js');

var useOutsideClick = require('../../../utilities/hooks/useOutsideClick.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var UtilityNav = function UtilityNav(_ref) {
  var className = _ref.className,
      utilityNavData = _ref.utilityNavData;

  var _useState = React.useState(null),
      _useState2 = slicedToArray['default'](_useState, 2),
      activeUtilityNavItem = _useState2[0],
      setActiveUtilityNavItem = _useState2[1];

  var ref = React.useRef();
  var UtilityNavClasses = index['default'](className, 'lanl-utility-nav');
  useOutsideClick.useOutsideClick(ref, function () {
    setActiveUtilityNavItem(null);
  });

  var handleClick = function handleClick(name) {
    name === activeUtilityNavItem ? setActiveUtilityNavItem(null) : setActiveUtilityNavItem(name);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    "data-testid": "lanl-utility-nav",
    className: UtilityNavClasses,
    ref: ref
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    className: "lanl-utility-nav-item",
    href: "https://discover.lanl.gov/"
  }, "News & Media"), /*#__PURE__*/React__default['default'].createElement("a", {
    className: "lanl-utility-nav-item",
    href: "https://www.lanl.jobs/"
  }, "Careers"), utilityNavData.map(function (_ref2) {
    var name = _ref2.name,
        lc_utility_item = _ref2.lc_utility_item;
    return /*#__PURE__*/React__default['default'].createElement(UtilityNavItem.UtilityNavItem, {
      items: lc_utility_item,
      key: name,
      onClick: function onClick() {
        return handleClick(name);
      },
      active: activeUtilityNavItem === name
    }, name);
  }));
};

UtilityNav.defaultProps = {
  utilityNavData: []
};
UtilityNav.propTypes = {
  className: PropTypes__default['default'].string,
  utilityNavData: PropTypes__default['default'].array
};
exports.UtilityNav = UtilityNav;
exports['default'] = UtilityNav;